/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { BankDetailsControllerService } from './services/bank-details-controller.service';
import { MySvgControllerService } from './services/my-svg-controller.service';
import { BankDetailsTypeControllerService } from './services/bank-details-type-controller.service';
import { MandateTypeControllerService } from './services/mandate-type-controller.service';
import { MandateStatusControllerService } from './services/mandate-status-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    BankDetailsControllerService,
    MySvgControllerService,
    BankDetailsTypeControllerService,
    MandateTypeControllerService,
    MandateStatusControllerService,
    ApiConfiguration
  ],
})
export class AccountMasterDataModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<AccountMasterDataModule> {
    return {
      ngModule: AccountMasterDataModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: AccountMasterDataModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('AccountMasterDataModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
